import {
  DefaultError,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
  useQuery as useTanstackQuery,
} from "@tanstack/react-query";

export const useQuery = <
  TQueryFnData = unknown,
  TError = DefaultError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  queryName: string,
  options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
): UseQueryResult<TData, TError> => {
  return useTanstackQuery<TQueryFnData, TError, TData, TQueryKey>({
    ...options,
    meta: {
      ...options.meta,
      name: queryName,
    },
  });
};
